export const colors = {
	1: '#efb815',
	2: '#ff8300',
	3: '#e04829',
	4: '#a1351f',
	5: '#682112',
	6: '#333437',
};
